"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var Editor = function (_a) {
    var videoId = _a.videoId, channel = _a.channel;
    var _b = ra_fetch_1.useApi('backend').show('videos', {
        id: videoId,
        resource: 'VideoFull',
        channel_id: channel.id,
    }), video = _b[0], setVideo = _b[1];
    var player = react_1.useRef();
    var pointer = react_1.useRef();
    var editor = react_1.useRef();
    var _c = react_1.useState(false), submitting = _c[0], setSubmitting = _c[1];
    var _d = react_1.useState(0), trimStart = _d[0], setTrimStart = _d[1];
    var _e = react_1.useState(0), trimEnd = _e[0], setTrimEnd = _e[1];
    var _f = react_1.useState(0), videoLength = _f[0], setVideoLength = _f[1];
    var _g = storybook_1.Hooks.useModal(), Modal = _g[0], setModal = _g[1], modalClose = _g[2];
    var _h = react_1.useState(0), pointerTime = _h[0], setPointerTime = _h[1];
    var _j = react_1.useState(false), videoState = _j[0], setVideoState = _j[1];
    var _k = react_1.useState(false), createCard = _k[0], setCreateCard = _k[1];
    var _l = react_1.useState(false), createChapter = _l[0], setCreateChapter = _l[1];
    function videoStateHandler() {
        setTimeout(function () {
            var state = jwplayer().getState();
            setVideoState(state);
        });
    }
    react_1.useEffect(function () {
        if (videoLength) {
            if (videoState === 'playing' || videoState === 'buffering' || videoState === 'paused') {
                var interval_1 = setInterval(function () {
                    var time = jwplayer().getCurrentTime();
                    time = parseFloat(time.toFixed(0));
                    var per = (((time / videoLength) * 100).toFixed(0));
                    pointer.current.style.left = per + '%';
                }, 1000);
                return function () { return clearInterval(interval_1); };
            }
            else {
                return false;
            }
        }
    }, [videoState]);
    function setPointer(event) {
        var editorWidth = parseInt(getComputedStyle(editor.current).width);
        var mousePosition = event.nativeEvent.x - 60;
        var time = ((mousePosition / editorWidth) * 100).toFixed(0);
        var endTime = ((time * videoLength) / 100);
        if (!videoState) {
            pointer.current.style.left = (event.nativeEvent.x - 80) + 'px';
        }
        setPointerTime(endTime);
        jwplayer().seek(endTime);
        jwplayer().pause();
    }
    var updating = video.data.status === 'draft';
    var mobile = window.innerWidth < 992;
    if (video.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    return react_1.default.createElement("div", { className: "bg-black relative" },
        react_1.default.createElement(Modal, null),
        !submitting && video.data.status === 'published' &&
            react_1.default.createElement("div", { className: 'storybook-pages-videosclips-player', ref: player, onClick: function () { return videoStateHandler(); } },
                react_1.default.createElement(storybook_1.Timelines.CardsVideoLayer, { id: "jwplayer-player-" + video.data.id, mediaId: video.data.external_id }),
                react_1.default.createElement(storybook_1.Players.Player, { channel: channel, autoplay: true, id: String(video.data.id), video: video.data, bustCache: true, onLoaded: function () {
                        setVideoLength(Math.round(jwplayer().getDuration()));
                    } })),
        react_1.default.createElement(storybook_1.Timelines.Container, null,
            (updating || mobile) &&
                react_1.default.createElement("div", { className: 'storybook-timelines-stop-edit' },
                    react_1.default.createElement("div", { className: 'storybook-timelines-stop-edit-wrapper' },
                        react_1.default.createElement(storybook_1.Texts.Primary, null, updating ? 'Wacht tot de video is geupload, dit kan enkele minuten duren. Ga terug naar het overzicht om de status te bekijken'
                            : 'Deze functionaliteit is op dit moment alleen beschikbaar op desktop.'),
                        react_1.default.createElement(storybook_1.Buttons.Link, { type: 'primary', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos" }, "Ga naar het video overzicht"))),
            react_1.default.createElement(storybook_1.Timelines.Header, null, videoLength > 0 && react_1.default.createElement(storybook_1.Timelines.Menu, { videoLength: videoLength, trimEnd: trimEnd, setTrimEnd: setTrimEnd, trimStart: trimStart, video: video.data, setModal: setModal, modalClose: modalClose, setVideo: setVideo, mediaId: video.data.external_id })),
            react_1.default.createElement("div", { className: 'storybook-timelines-editor-wrapper', ref: editor },
                react_1.default.createElement(storybook_1.Timelines.Editor, null,
                    react_1.default.createElement("div", { className: "storybook-timelines-editor-pointer " + (pointerTime ? 'active' : ''), ref: pointer },
                        react_1.default.createElement("span", { className: 'storybook-timelines-editor-pointer-plus-card', onClick: function () { return setCreateCard(true); } }),
                        react_1.default.createElement("span", { className: 'storybook-timelines-editor-pointer-plus-chapter', onClick: function () { return setCreateChapter(true); } })),
                    Boolean(videoLength) && react_1.default.createElement(storybook_1.Timelines.Timeline, { timeline: videoLength }),
                    react_1.default.createElement(storybook_1.Timelines.TrackContainer, null,
                        react_1.default.createElement(storybook_1.Timelines.TrackLegend, { setModal: setModal, type: 'trimming', icon: 'video-camera' }),
                        react_1.default.createElement(storybook_1.Timelines.Track, null,
                            react_1.default.createElement(storybook_1.Timelines.VideoTrack, { videoLength: videoLength, setVideoLength: setVideoLength, thumbnail: video.data.thumbnail, trimEnd: trimEnd, trimStart: trimStart, setTrimEnd: setTrimEnd, setTrimStart: setTrimStart }))),
                    react_1.default.createElement(storybook_1.Timelines.TrackContainer, null,
                        react_1.default.createElement(storybook_1.Timelines.TrackLegend, { setModal: setModal, type: 'cards', icon: 'annotation' }),
                        react_1.default.createElement(storybook_1.Timelines.Track, null,
                            react_1.default.createElement("div", { className: 'absolute inset-0 z-20', onMouseUp: setPointer }),
                            react_1.default.createElement(storybook_1.Timelines.TrackContent, null,
                                react_1.default.createElement(storybook_1.Timelines.CardsTrack, { mediaId: video.data.external_id, setModal: setModal, modalClose: modalClose, player: player, pointerTime: pointerTime, seconds: videoLength, setSubmitting: setSubmitting, videoLength: videoLength, createCard: createCard, setCreateCard: setCreateCard })))),
                    react_1.default.createElement(storybook_1.Timelines.TrackContainer, null,
                        react_1.default.createElement(storybook_1.Timelines.TrackLegend, { setModal: setModal, type: 'chapters', icon: 'flag' }),
                        react_1.default.createElement(storybook_1.Timelines.Track, null,
                            react_1.default.createElement("div", { className: 'absolute inset-0 z-20', onMouseUp: setPointer }),
                            react_1.default.createElement(storybook_1.Timelines.TrackContent, null,
                                react_1.default.createElement(storybook_1.Timelines.ChaptersTrack, { setPoi: true, setModal: setModal, modalClose: modalClose, mediaId: video.data.external_id, seconds: videoLength, pointerTime: pointerTime, setSubmitting: setSubmitting, videoLength: videoLength, createChapter: createChapter, setCreateChapter: setCreateChapter }))))))));
};
exports.Editor = Editor;
